import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import {Injectable} from '@angular/core';
import {Headers, Http, Jsonp, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {Subscription} from 'rxjs/Subscription';

import { environment } from '../../../environments/environment';
import { LogEntry } from '../model/log.entry';
import {SessionService} from './session.service';

const API_URL = environment.apiUrl;

@Injectable()
export class LogEntriesService {
    constructor(private http: Http, private sessionService: SessionService) {}

    public getAllByUserId(_id: string, limit: number): Observable<LogEntry[]> {
        const headers = new RequestOptions({
            headers: new Headers({'Authorization': 'Bearer ' + localStorage.getItem('token')})
        });

        return this.http.get(API_URL + '/v1/users/' + _id + '/log.entries?limit=' + limit, headers)
            .map(response => {
                return response.json();
            })
            .catch(this.handleError.bind(this));
    }

    private handleError(error: Response|any) {
        console.log(error);
        return this.sessionService.handleAuthenticatedRequestError(error);
    }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/data/services/log.entries.service.ts